// extracted by mini-css-extract-plugin
module.exports = {"timeDate":"MessageSentWithFile_timeDate__cGlOr","sentMessage":"MessageSentWithFile_sentMessage__bGQXN","outgoingMessage":"MessageSentWithFile_outgoingMessage__SzAlO"};